import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "api/axios";
import AlertNotification from "components/CustomWidgets/alertNotification";

export const useBlockChat = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (thread_id) => {
      const { data } = await api.post("chat/chat-thread-actions/block/", {
        thread_id,
      });
      return data;
    },
    onSuccess: (response) => {
      queryClient.invalidateQueries(["chat-threads"]);
        AlertNotification("success",response.message );
      }
  });
};
